import React from 'react';
import Style from './style/footer.module.css';

function Footer(){
    return(
        <div className={Style.footer}>
            <h4>Create by AslamBaba</h4>
        </div>
    )
}

export default Footer;